import React, { useEffect, useState } from "react";
import { useHeader } from "../../../../context/HeaderContext";
import "../../Deposit/DepositMethod/DepositMethod.css";
import PremiumBankTransfer from "../PaymentMethods/PremiumBankTransfer";
import PremiumUSDTTransfer from "../PaymentMethods/PremiumUSDTTransfer";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import BottomMenu from "../../../../components/Dashboard/BottomMenu";
import { useGetManageTabsStatusQuery } from "../../../../services/userApi";
import PremiumUPITransfer from "../PaymentMethods/PremiumUPITransfer";
import PremiumPhonePeTransfer from "../PaymentMethods/PremiumPhonePeTransfer";
import PremiumGPayTransfer from "../PaymentMethods/PremiumGPayTransfer";
import PremiumPaytmTransfer from "../PaymentMethods/PremiumPaytmTransfer";
import PremiumHistoryCard from "./PremiumHistoryCard";
import { useGetSpecificUserPremiumHistoryQuery } from "../../../../services/userApi";
import { useGetSpecificUserPremium_PlusAmountQuery } from "../../../../services/userApi";
import PremiumPointTransfer from "../PaymentMethods/PremiumPointTransfer";
export default function PremiumMethod() {
  // dummyData.js
  let PremiumHistory = [
    {
      username: "abhaykadu",
      fullName: "Abhay Kadu",
      isPremiumStatus: "succeed",
      payment_mode: "bank_payment",
      date: "Mon Aug 18 2025",
      time: "12:02:43 PM",
      imageUrl: "https://cdn-icons-png.flaticon.com/512/2331/2331941.png",
    },
    {
      username: "abhaykadu",
      fullName: "Abhay Kadu",
      isPremiumStatus: "rejected",
      payment_mode: "bank_payment",
      date: "Mon Aug 18 2025",
      time: "12:39:10 PM",
      imageUrl: "https://cdn-icons-png.flaticon.com/512/2331/2331941.png",
    },
    {
      username: "abhaykadu",
      fullName: "Abhay Kadu",
      isPremiumStatus: "rejected",
      payment_mode: "bank_payment",
      date: "Mon Aug 18 2025",
      time: "2:21:22 PM",
      imageUrl: "https://cdn-icons-png.flaticon.com/512/2331/2331941.png",
    },
  ];
  const { setScreenName } = useHeader();
  useEffect(() => {
    setScreenName("Payment Method");
    return () => {
      setScreenName(null);
    };
  }, []);
  // let isPremiumPlus=false;

  const [method, setMethod] = useState("point");
  const [paymentmethod, setpaymentmethod] = useState("point_payment");
  const { country } = useSelector((state) => state.userProfile);
  const navigate = useNavigate();
  const location = useLocation();
  const amount = location.state?.amount;
  console.log("amount", amount);
  const [isVisible, setIsVisible] = React.useState(false);

  const { data: tabStatus, isLoading, isError } = useGetManageTabsStatusQuery();
  // console.log('PremiumHistoryPremiumHistoryPremiumHistory',premiumHistory)
  // console.log("tabStatus", tabStatus);
  const {
    data: premiumHistory,
    isLoading: loading,
    refetch,
    isError: PremiumError,
  } = useGetSpecificUserPremiumHistoryQuery({ paymentmethod, isPremiumPlus: false });

  useEffect(() => {
    setIsVisible(true);
  }, []);
  let ImgUrl =
    method == "bank"
      ? "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1747025270/all_leagues/l0m6v4rptdwbettjqgt9.png"
      : method == "point"
        ? "https://i.postimg.cc/1zKkRz5N/point.png"
        : method == "BNB"
          ? "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1747022933/all_leagues/jktzgod6ievq7gk4znpz.png"
          : method == "UPI"
            ? "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1747023504/all_leagues/axrkcrvw6zrqycmwcdl3.png"
            : method == "GPay"
              ? "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1745838625/all_leagues/wuogpqorxvzmdlofnmlc.png"
              : method == "Paytm"
                ? "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1745838457/all_leagues/skh8jj6bk4mkxxmwjuy2.png"
                : method == "PhonePe"
                  ? "https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1745838770/all_leagues/mi8j09rzdcnicw4lnfcc.png"
                  : "https://cdn-icons-png.flaticon.com/512/2331/2331941.png";
  return (
    <>
      <div className="tpu__dashboard__wrapper layoutContainer">
        <div className="tpu__createTask__wrapper layoutContainer">
          <div
            className="layoutContainer"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
            }}
          >
            <div className="tpu__createTask__section__area">
              <div className="deposit-method-options">
                {
                  <button
                    onClick={() => {
                      setMethod("point");
                      setpaymentmethod("point_payment");
                    }}
                    className={`deposit__status-button ${method === "point" ? "active" : ""
                      }`}
                  >
                    <img
                      style={{ marginRight: 6 }}
                      src="https://i.postimg.cc/1zKkRz5N/point.png"
                      alt="Point Paymentś"
                      className="deposit-method-icon"
                    />
                    <span>Point</span>
                  </button>
                }

                {country === "India" &&
                  tabStatus?.membership_bank_transfer_section_business_show && (
                    <button
                      onClick={() => {
                        setMethod("bank");
                        setpaymentmethod("bank_payment");
                      }}
                      className={`deposit__status-button ${method === "bank" ? "active" : ""
                        }`}
                    >
                      <img
                        style={{ marginRight: 6 }}
                        src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1747025270/all_leagues/l0m6v4rptdwbettjqgt9.png"
                        alt="Bank Transfer"
                        className="deposit-method-icon"
                      />
                      <span>Bank Transfer</span>
                    </button>
                  )}
                {tabStatus?.membership_usdt_section_business_show && (
                  <button
                    onClick={() => {
                      setMethod("BNB");
                      setpaymentmethod("usdt_payment");
                    }}
                    className={`deposit__status-button ${method === "BNB" ? "active" : ""
                      }`}
                  >
                    <img
                      style={{
                        width: 18,
                        height: 18,
                        marginRight: 6,
                      }}
                      src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1747022933/all_leagues/jktzgod6ievq7gk4znpz.png"
                      alt="Instant Deposit"
                    />
                    <span>BNB USDT(Manual Deposit)</span>
                  </button>
                )}
                {country === "India" &&
                  // tabStatus?.membership_upi_section_business_show &&
                  method == "UPI" && (
                    <button
                      onClick={() => {
                        setMethod("UPI");
                        setpaymentmethod("upi_payment");
                      }}
                      className={`deposit__status-button ${method === "UPI" ? "active" : ""
                        }`}
                    >
                      <img
                        style={{ marginRight: 6 }}
                        src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1747023504/all_leagues/axrkcrvw6zrqycmwcdl3.png"
                        alt="UPI"
                      />
                      <span>UPI</span>
                    </button>
                  )}
                {country === "India" &&
                  tabStatus?.membership_gpay_section_business_show && (
                    <button
                      onClick={() => {
                        setMethod("GPay");
                        setpaymentmethod("gpay_payment");
                      }}
                      className={`deposit__status-button ${method === "GPay" ? "active" : ""
                        }`}
                    >
                      <img
                        style={{ marginRight: 6 }}
                        src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1745838625/all_leagues/wuogpqorxvzmdlofnmlc.png"
                        alt="GPay"
                        className="deposit-method-icon"
                      />
                      <span>GPay</span>
                    </button>
                  )}
                {country === "India" &&
                  tabStatus?.membership_phonepe_section_business_show && (
                    <button
                      onClick={() => {
                        setMethod("PhonePe");
                        setpaymentmethod("phonepe_payment");
                      }}
                      className={`deposit__status-button ${method === "PhonePe" ? "active" : ""
                        }`}
                    >
                      <img
                        style={{ marginRight: 6 }}
                        src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1745838770/all_leagues/mi8j09rzdcnicw4lnfcc.png"
                        alt="PhonePe"
                        className="deposit-method-icon"
                      />
                      <span>PhonePe</span>
                    </button>
                  )}
                {country === "India" &&
                  tabStatus?.membership_paytm_section_business_show && (
                    <button
                      onClick={() => {
                        setMethod("Paytm");
                        setpaymentmethod("paytm_payment");
                      }}
                      className={`deposit__status-button ${method === "Paytm" ? "active" : ""
                        }`}
                    >
                      <img
                        style={{ marginRight: 6 }}
                        src="https://res.cloudinary.com/dztzqhifb/image/upload/f_auto,q_auto/v1745838457/all_leagues/skh8jj6bk4mkxxmwjuy2.png"
                        alt="Paytm"
                        className="deposit-method-icon"
                      />
                      <span>Paytm</span>
                    </button>
                  )}
              </div>
              {country === "India" &&
                tabStatus?.membership_bank_transfer_section_business_show &&
                method == "bank" && <PremiumBankTransfer></PremiumBankTransfer>}
              {tabStatus?.membership_usdt_section_business_show &&
                method == "BNB" && <PremiumUSDTTransfer></PremiumUSDTTransfer>}
              {country === "India" &&
                tabStatus?.membership_upi_section_business_show &&
                method == "UPI" && <PremiumUPITransfer></PremiumUPITransfer>}
              {country === "India" &&
                tabStatus?.membership_phonepe_section_business_show &&
                method == "PhonePe" && (
                  <PremiumPhonePeTransfer></PremiumPhonePeTransfer>
                )}
              {country === "India" &&
                tabStatus?.membership_gpay_section_business_show &&
                method == "GPay" && <PremiumGPayTransfer></PremiumGPayTransfer>}
              {country === "India" &&
                tabStatus?.membership_paytm_section_business_show &&
                method == "Paytm" && (
                  <PremiumPaytmTransfer></PremiumPaytmTransfer>
                )}
              {method === "point" && (
                <PremiumPointTransfer></PremiumPointTransfer>
              )}
              <div>
                <h3>Premium History</h3>
                {loading && <h1>Premium History Loading...</h1>}
                {console.log("premium history", premiumHistory)}
                <div
                  style={{
                    marginTop: "5px",
                    maxHeight: "400px",
                    overflowY: "auto",
                  }}
                >
                  {premiumHistory?.data?.map((item, index) => (
                    <PremiumHistoryCard
                      key={index}
                      fullName={item.fullName}
                      payment_mode={item.payment_mode}
                      isPremiumStatus={
                        item?.isPremiumStatus || item?.isPremiumPlusStatus
                      }
                      date={item.date}
                      time={item.time}
                      imageUrl={ImgUrl}
                    />
                  ))}
                </div>
              </div>
            </div>
            <BottomMenu />
          </div>
        </div>
      </div>
    </>
  );
}
